import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const container = document.getElementById('root');
// index.html always ships the div, so a miss here means the HTML was replaced or
// the script ran on the wrong page. Fail loudly instead of silently rendering
// nothing on a page whose whole job is paging a human.
if (container === null) {
  throw new Error('Vertex Rescue could not start: #root is missing from the document.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
